import { alpha } from "@mui/material/styles";
import { layout, radius, spacing, typography } from "./designTokens";
import { LAYOUT_HEADER_HEIGHT } from "./appConstants";

/**
 * MUI `sx` prop'ları — mobil ile hizalı sayfa padding/margin.
 * MUI spacing birimi: 8px → 2 = 16px, 3 = 24px
 */
export const pagePaddingSx = {
  px: { xs: 2, md: 3 },
  py: { xs: 2, md: 3 },
};

export const pagePaddingX = {
  px: { xs: 2, md: 3 },
};

export const pageContentMarginSx = {
  mx: { xs: 2, md: 3 },
};

export const pageSectionGapSx = {
  gap: 2,
};

/** Liste sayfaları — ana sayfa ile aynı dış padding */
export const listPageShellSx = {
  ...pagePaddingSx,
};

/** Filtre / aksiyon satırı — üst kabuk zaten pagePaddingSx ile hizalı */
export const listPageToolbarSx = {
  mb: 2,
  display: "flex",
  gap: 2,
  alignItems: "center",
  flexWrap: "wrap",
};

/** @deprecated Üst kabukta padding olduğu için ek yatay margin kullanmayın */
export const listPageContentSx = {};

/** Liste / Paper iç padding */
export const pagePaperPaddingSx = {
  p: { xs: 2, md: 3 },
};

/** Banner alt metin — sabit 150px yerine responsive */
export const bannerTextSx = {
  maxWidth: 720,
  mx: "auto",
  px: { xs: 0, sm: 2, md: 4 },
};

/**
 * Doktor paneli ile aynı sayfa arka planı (gradient + minHeight).
 * @param {import('@mui/material').Theme} theme
 * @param {object} [extra]
 */
export const getPageGradientSx = (theme, extra = {}) => {
  const lightBgStart = alpha(theme.palette.primary.main, 0.01);
  const lightBgEnd = alpha(theme.palette.primary.main, 0.2);
  return {
    minHeight: `calc(100vh - ${LAYOUT_HEADER_HEIGHT}px)`,
    background: `linear-gradient(135deg, ${lightBgStart} 0%, ${lightBgEnd} 100%)`,
    ...extra,
  };
};

/**
 * @param {import('@mui/material').Theme} theme
 * @param {object} [extra]
 */
export const getPageContainerStyles = (theme, extra = {}) => ({
  width: "100%",
  padding: theme.spacing(2),
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(3),
  },
  ...extra,
});

/**
 * @param {import('@mui/material').Theme} theme
 * @param {object} [extra]
 */
export const getPagePaperStyles = (theme, extra = {}) => ({
  width: "100%",
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(5),
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(5),
  },
  ...extra,
});

export const pageStyleConstants = {
  layout,
  spacing,
  radius,
  typography,
};
